import React, { FunctionComponent, ReactNode } from 'react'
import clsx from 'clsx'
import styles from './style.module.scss'
import { PaymentIcon, PaymentIconNames } from '../Icon'
import { CardBrand } from '@afterpay/types'

import { PaymentIconsDirection, DEFAULT_ALLOWED_CARD_BRAND } from './types'
import { DesignLanguage, useIsDesignLanguage, useThemeClass } from '../Theme'

type CSSClasses = keyof typeof styles
export interface PaymentIconsProps {
  allowedCardBrand?: CardBrand[]
  direction?: PaymentIconsDirection
  selectedCardBrand?: CardBrand
  testNameSpace?: string
}

export const PaymentIconNameMapping: Record<CardBrand, PaymentIconNames> = {
  [CardBrand.MASTERCARD]: 'Mastercard',
  [CardBrand.VISA]: 'Visa',
  [CardBrand.AMEX]: 'Amex',
  [CardBrand.DINERS_CLUB]: 'Dinersclub',
  [CardBrand.DISCOVER]: 'Discover',
}

export const PaymentIcons: FunctionComponent<PaymentIconsProps> = ({
  allowedCardBrand = [CardBrand.MASTERCARD, CardBrand.VISA],
  direction = PaymentIconsDirection.Horizontal,
  selectedCardBrand,
  testNameSpace = '',
}) => {
  const componentStyles = clsx(styles.component, styles[`direction${direction}` as CSSClasses])
  const themeClass = useThemeClass()
  const isBronteDesign = useIsDesignLanguage(DesignLanguage.Bronte)

  const renderIcons = (): ReactNode =>
    DEFAULT_ALLOWED_CARD_BRAND.map((cardType, index) => {
      const isAllowed = allowedCardBrand.includes(cardType)
      const isSelected = selectedCardBrand === cardType
      const iconStyles = clsx(styles.icon, isSelected && styles.selectedIcon, styles[themeClass])

      return isAllowed ? (
        <div
          key={`PaymentIcons-${index}`}
          className={iconStyles}
          {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-component-${cardType}` })}
        >
          <PaymentIcon name={PaymentIconNameMapping[cardType]} />
          {isSelected && isBronteDesign && (
            <span data-testid='selected-card-animation' className={styles.animWrapper} role='presentation'>
              <svg viewBox='0 0 44 28'>
                <rect rx='3' ry='3' className={styles.rect}></rect>
              </svg>
            </span>
          )}
        </div>
      ) : null
    })

  return (
    <div className={componentStyles} {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-component` })}>
      {renderIcons()}
    </div>
  )
}
